// extracted by mini-css-extract-plugin
export default {"root":"title__root__NIrhp","text":"title__text__lqX3B"};